<div class="layout-container" [ngClass]="styleClass">
  <app-topbar></app-topbar>
  <app-sidebar></app-sidebar>

  <div class="layout-content-wrapper" [class.main-page]="isMainPage">
    <div id="layout-content" class="layout-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div *ngIf="layoutService.state.staticMenuMobileActive" class="layout-mask"></div>
</div>
<app-progress-spinner></app-progress-spinner>
